import type { ConceptDef } from '../types';

export const simpleAddition: ConceptDef = {
  kind: 'tileMatch',
  id: 'simple-addition',
  label: 'Simple Addition',
  category: 'Math',
  description: 'Hear a simple sum; tap the answer.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'Two plus one.', answer: '3' },
      { say: 'Two plus two.', answer: '4' },
      { say: 'Three plus two.', answer: '5' },
      { say: 'Four plus two.', answer: '6' },
      { say: 'Five plus two.', answer: '7' },
      { say: 'Three plus five.', answer: '8' },
    ],
  },
};
